import { createDefaultState } from './defaults';
import type { StatusCampaignPayloadBuilderState } from './types';

function snapshotState(state: StatusCampaignPayloadBuilderState): string {
  return JSON.stringify({
    mode: state.mode,
    campaignId: state.campaignId.trim(),
    slug: state.slug.trim(),
    termsSlug: state.termsSlug.trim(),
    heroTitle: state.heroTitle.trim(),
    heroSubtitle: state.heroSubtitle.trim(),
    heroDescription: state.heroDescription.trim(),
    heroCtaText: state.heroCtaText.trim(),
    heroImageId: state.heroImageId.trim(),
    allowedRegions: [...(state.allowedRegions ?? [])].sort(),
    programs: state.programs.map((program) => ({
      programName: program.programName.trim(),
      logoImageId: program.logoImageId.trim(),
      tierMappings: program.tierMappings.map((mapping) => ({
        sourceTier: mapping.sourceTier.trim(),
        targetSocieteTier: mapping.targetSocieteTier.trim(),
      })),
    })),
    conditions: state.conditions.map((row) => ({
      icon: row.icon,
      title: row.title.trim(),
      description: row.description.trim(),
    })),
    howItWorks: state.howItWorks.map((row) => ({
      title: row.title.trim(),
      description: row.description.trim(),
    })),
    terms: state.terms.map((term) => term.trim()).filter(Boolean),
    applicationPeriodFrom: state.applicationPeriodFrom,
    applicationPeriodTo: state.applicationPeriodTo,
    faqs: state.faqs.map((row) => ({
      question: row.question.trim(),
      answer: row.answer.trim(),
    })),
    challengeCardTitleSuffix: state.challengeCardTitleSuffix.trim(),
    challengeCardSubtitleBefore: state.challengeCardSubtitleBefore.trim(),
    challengeCardSubtitleAfter: state.challengeCardSubtitleAfter.trim(),
    challengeCardBackground: state.challengeCardBackground,
    evidenceMinPhotos: state.evidenceMinPhotos,
    evidenceVerificationImageId: state.evidenceVerificationImageId.trim(),
    evidencePhotoHints: state.evidencePhotoHints.map((value) => value.trim()).filter(Boolean),
    evidenceAcceptedFormats: state.evidenceAcceptedFormats.map((value) => value.trim()).filter(Boolean),
    evidenceProofRequirements: state.evidenceProofRequirements.map((value) => value.trim()).filter(Boolean),
    successSteps: state.successSteps.map((row) => ({
      key: row.key,
      title: row.title.trim(),
      description: row.description.trim(),
    })),
    partnerName: state.partnerName.trim(),
    partnerLogoImageId: state.partnerLogoImageId.trim(),
    tiersGranted: [...state.tiersGranted].sort(),
    secondaryTitle: state.secondaryTitle.trim(),
    secondarySubtitle: state.secondarySubtitle.trim(),
  });
}

/** Returns true when the user has entered or changed any form values from the mode defaults. */
export function hasFormProgress(state: StatusCampaignPayloadBuilderState, loadJson: string): boolean {
  if (loadJson.trim()) {
    return true;
  }
  const baseline = createDefaultState(state.mode);
  return snapshotState(state) !== snapshotState(baseline);
}
